import { render, staticRenderFns } from "./tag_cloud_table.vue?vue&type=template&id=5606f871&scoped=true&"
import script from "./tag_cloud_table.vue?vue&type=script&lang=js&"
export * from "./tag_cloud_table.vue?vue&type=script&lang=js&"
import style0 from "./tag_cloud_table.vue?vue&type=style&index=0&id=5606f871&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5606f871",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCard,VSimpleTable})
